export default class {
  static projectName = "ARCEE";
  static userData = "USER_DATA";
  static themeColor = "#99c95e";
  static emailRjx = /\S+@\S+\.\S+/;
  // static API_URL = "http://192.168.1.148:7001";
  // static API_URL = "http://3.110.238.4:7001";
  static API_URL = "https://api.arceeindustries.in";
}
